import React, { Component } from "react";
import Headers from "../Layouts/Headers";
import { Gynecology2Sidebar } from "../Layouts/Gynecology2Sidebar";
import axios from "axios";
import $ from "jquery";
import { MDBTableEditable } from "../_mdbcomponents/components/pro/TableEditable/TableEditable";
import { MDBCard } from "../_mdbcomponents/components/Card/Card";
import { MDBCardHeader } from "../_mdbcomponents/components/Card/CardHeader/CardHeader";
import { MDBCardBody } from "../_mdbcomponents/components/Card/CardBody/CardBody";

export class G2PreviousObstetricHistory extends Component {
  constructor(props) {
    super(props);

   

    const url = "";
    this.state = {
      Gravidity: "",
      Parity: "",
      Term: "",
      Preterm: "",
      Abortion: "",
      PostTerm: "",
      NumChildrenAlive: "",
      AgeLastInfant: "",
      NumStillBirth: "",
      NumNeonatalDeathFirstWeek: "",
      NumNeonatalDeath8thTo28thDays: "",
      visitid: "",
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    //this.PrintWindow = this.PrintWindow.bind(this);
  }

  componentDidMount() {}

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
    var value = $(".PreviousDone").val();
    if (value == "yes") {
      $(".PreplanTable").show();
    } else {
      $(".PreplanTable").hide();
    }
  }

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
    };
    event.preventDefault();
    // console.log(this.state)
    axios
      .post(
        this.api_url+"gynecology2/obstetrichistory/main",
        this.state,
        { headers: headers }
      )
      .then((response) => {
        console.log(response);
        if (response.data["status"]) {
          $(".alert-success").show();
          setTimeout(function () {
            window.location.href = "/gynecology2/previous/pregancy";
          }, 500);
        }
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  };
  render() {
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };
    const {
      Gravidity,
      Parity,
      Term,
      Preterm,
      Abortion,
      PostTerm,
      NumChildrenAlive,
      AgeLastInfant,
      NumStillBirth,
      NumNeonatalDeathFirstWeek,
      NumNeonatalDeath8thTo28thDays,
      visitid,
    } = this.state;
    return (
      <div>
        <Headers />
        <Gynecology2Sidebar />

        <main className="content-container ">
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <div className="form-row pt-4">
                <div className="col-md-12 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}>
                    Previous Obstetrics History
                  </p>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Gravidity
                    </h6>
                    <select
                      className="form-control"
                      onChange={this.handleChange}
                      value={Gravidity}
                      name="Gravidity"
                      required
                    >
                      <optgroup label="" className="confirm_card">
                        <option selected disabled></option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </optgroup>
                    </select>
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Parity
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Parity}
                      name="Parity"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Term
                    </h6>
                    <select
                      className="form-control"
                      onChange={this.handleChange}
                      value={Term}
                      name="Term"
                      required
                    >
                      <optgroup label="" className="confirm_card">
                        <option selected disabled></option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </optgroup>
                    </select>
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Preterm
                    </h6>
                    <select
                      className="form-control"
                      onChange={this.handleChange}
                      value={Preterm}
                      name="Preterm"
                      required
                    >
                      <optgroup label="" className="confirm_card">
                        <option selected disabled></option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </optgroup>
                    </select>
                  </div>
                </div>
              </div>

              <div className="form-row pt-4">
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Abortion
                    </h6>
                    <select
                      className="form-control"
                      onChange={this.handleChange}
                      value={Abortion}
                      name="Abortion"
                      required
                    >
                      <optgroup label="" className="confirm_card">
                        <option selected disabled></option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </optgroup>
                    </select>
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Number of Children Alive
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={NumChildrenAlive}
                      name="NumChildrenAlive"
                      type="text"
                      required
                    />
                  </div>
                </div>

                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Age Of Last Infant{" "}
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={AgeLastInfant}
                      name="AgeLastInfant"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Number Of StillBirth{" "}
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={NumStillBirth}
                      name="NumStillBirth"
                      type="text"
                      required
                    />
                  </div>
                </div>
              </div>

              <div className="form-row pt-4">
                <div className="col-md-12 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Number of Neonatal Death in the first week
                    </h6>
                    <input
                      className="form-control"
                      name="NumNeonatalDeathFirstWeek"
                      onChange={this.handleChange}
                      value={NumNeonatalDeathFirstWeek}
                      type="text"
                    />
                  </div>
                </div>
                <div className="col-md-12 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Number of Neonatal Death between the 8th to 28th days
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={NumNeonatalDeath8thTo28thDays}
                      name="NumNeonatalDeath8thTo28thDays"
                      type="text"
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="form-row ">
                <div className="col-md-4 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}></p>
                </div>

                <div className="col-md-4 p-2">
                  {/* <div className="py-1">
                                        <h6 className="text-capitalize" style={fontFamilyNunito}>Age Last Infant</h6><input className="form-control" onChange={this.handleChange} value={AgeLastInfant} name="AgeLastInfant" type="text" required />
                                    </div> */}
                </div>
              </div>

              <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Previous Obstetrics History Saved
                Successfully.
              </div>
              <div className="row">
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default G2PreviousObstetricHistory;
